import { Enrolment } from '@/models/enrolment';

import { Event } from './event';

export class EnrolmentEnrichedEvent extends Event<Enrolment> {}
